import { useAtomValue } from 'jotai';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useMemo } from 'react';
import { KanbanCard } from './KanbanCard';
import { ZoneAndHistory, ZoneStatus } from '@/__generated__/graphql';
import { KanbanColumnStyles } from './styles';
import * as state from '@/state';
import { ZoneStatusMapper } from '../common';

type Props = {
  status: ZoneStatus;
  zones: Array<ZoneAndHistory>;
};

const containerStyles = { p: 1 };

export const KanbanColumn = ({ status, zones }: Props) => {
  const searchTerm = useAtomValue(state.zonesSearchTerm);

  const filteredZones = useMemo(() => {
    return zones.filter((zone) => {
      if (!zone?.name) return false;
      return zone.name.includes(searchTerm);
    });
  }, [searchTerm, zones]);

  const filteredZonesMemo = useMemo(() => {
    return filteredZones.map((zone) => <KanbanCard key={zone._id} zone={zone} />);
  }, [filteredZones]);

  return (
    <Box sx={containerStyles}>
      <Box sx={KanbanColumnStyles.header}>
        <Typography variant="h6" fontWeight="bolder">
          {ZoneStatusMapper[status]}
        </Typography>
        <Typography sx={KanbanColumnStyles.zoneCount}>{filteredZones.length}</Typography>
      </Box>

      <Box>{filteredZonesMemo}</Box>
    </Box>
  );
};
